import { useEffect, useState } from 'react'
import { useSyncProgressStore } from '@/lib/store/useSyncProgressStore'

/**
 * Thin progress bar fixed at the very top of the viewport.
 * Visible only while initial sync is running.
 */
export function SyncProgressBar() {
  const { syncing, progress, label } = useSyncProgressStore()
  const [visible, setVisible] = useState(false)

  // Keep the bar visible briefly after reaching 100% to show completion
  useEffect(() => {
    if (syncing) {
      setVisible(true)
    } else if (progress === 100) {
      const t = setTimeout(() => setVisible(false), 600)
      return () => clearTimeout(t)
    }
  }, [syncing, progress])

  if (!visible) return null

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999]">
      {/* Track */}
      <div className="h-0.5 w-full bg-[var(--color-border-subtle)]">
        {/* Fill */}
        <div
          className="h-full bg-[var(--color-accent-amber)] transition-all duration-300 ease-out"
          style={{ width: `${progress}%` }}
        />
      </div>
      {/* Label — only shown when sync is in progress */}
      {syncing && (
        <div className="absolute right-3 top-1 text-[10px] text-[var(--color-text-muted)] bg-[var(--color-bg-base)]/90 px-1.5 py-0.5 rounded-sm">
          {label}
        </div>
      )}
    </div>
  )
}
